export class MissingFirebaseCloudFunctionAPIEmulatorConfig extends Error {
  constructor() {
    super(
      "Firebase Cloud Functions API emulator configs are missing. Check .env file"
    );
    this.name = "Firebase Cloud Functions API emulator config missing";
  }
}
